// extracted by mini-css-extract-plugin
export default {"btn":"BrownButton_btn__eAWTL"};